export const ROUTES = {
	ROOT: "/",
	LOGIN: "/login",
	FORGOT_PASSWORD: "/forgot-password",
	RESET_PASSWORD: "/resetpassword/:token",
	ADMIN: {
		ROOT: "/admin",
		USER_MANAGEMENT: "/admin/usermanagement",
		COUNTY_MASTER: "/admin/countymaster",
		AGENT_MASTER: "/admin/agentmaster",
		ALL_COUNTRY: "/admin/allcountry",
		FRAUD_RISK_CONFIGURATION: "/admin/fraudriskconfiguration",
		COMPLIANCE: "/admin/compliance",
		FRAUD_SCREEN: "/admin/fraudscreen",
		PARTNER: "/admin/partner",
		PARTNER_DETAILS: ":partnerdetails/:partnerid/:type",
		PARTNER_PAYMENT: ":partnerdetails/payment/:partnerid/:type",
		PARTNER_ADMIN: ":partner/admin/:partnerid",
		PARTNER_ADMIN_FEES: ":partner/admin/fees",
		PARTNER_ADMIN_USERINFO: ":partner/admin/userinfo",
		DASHBOARD: ":dashboard",
		MANAGE_PARTNER_LIMITS: "/admin/partner-limits",
		INVOICE_PARTNER: "/admin/invoice-partner",
		INVOICES: "/admin/invoices",
		REFERRER: "/admin/referrer",
		REFER_USERS: "/admin/refer-users",
		INVOICE_USER: "/admin/users",
		INVOICE_CREATOR_PROFILE: "/admin/creator/profile/:id",
		INVOICE_PARTNER_TABS: "/admin/invoice-partner/detail/:id",
		MANAGE_DROPDOWNS: "/admin/dropdowns",
		TRANSACTION_DETAILS: "/admin/transaction-details/:paymentId/:partnerId",
		MANAGE_QUOTE: "/admin/quote",
		SWIREPAY_PAYMENTS:"/admin/swirepay-payments",
		MANAGE_SANCTION_VENDORS:"/admin/sanction-vendors"
	},
	PAYMENT_INFO: "/paymentinfo",
	PAYOUT: "/payout",
	VIEW_TRANSACTION: "/viewtransaction",
	PROFILE: "/profile",
	TRANSACTION_DETAILS: "/transaction-details/:paymentId/:partnerId",
	SANCTIONS_PROGRAM: "/sanctionsprogram"
};
